import { CURRENT_PRIVILEGE } from "../actions/page.actions";

const pageReducer = (state={}, action) => {
    switch(action.type){
        case CURRENT_PRIVILEGE:
            return {
                ...state,
                pagePrivilege: action.data
            }
        default:
            return state;
    }
}

export default pageReducer;